import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const TwoFaPage = lazy(() => import("./TwoFaPage"));

const TwoFaPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <TwoFaPage />
    </Suspense>
  );
};

export default TwoFaPageLazy;
